import { makeStyles, Popover } from "@material-ui/core";
import CustomTooltip from "components/CustomTooltip";
import { useState } from "react";
import { Button } from "react-admin";
import ChangePickupLocationButton from "./ChangePickupLocationButton";
import ManageStudentsButton from "./ManageStudentsButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CancelIcon from "@material-ui/icons/Cancel";

interface IPopoverActionButton {
  routeLocationData: any;
  selectedStudentIds: number[];
  manageStudentCallback: any;
  changeLocationCallback: any;
  removeLocationListCallback: any;
  schoolData: ISchool;
  busScheduleType: string;
  routesData: any;
  selectedMarkers: any;
}

const useStyles = makeStyles({
  MoreButton: {
    padding: 0,
    marginLeft: "5px",
    minWidth: "10px",
    height: "30px",
    backgroundColor: "#E0E0E0",
    boxShadow: "0 4px 8px rgb(224 224 224 / 30%)",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 30,
      color: "#4E4E4E",
    },
    "&:hover": {
      backgroundColor: "#E0E0E0 !important",
    },
  },
  boxPopover: {
    padding: "10px 20px 10px 15px",
    display: "flex",
  },
  removeLocationButton: {
    padding: "5px",
    marginLeft: "5px",
    minWidth: "10px",
    backgroundColor: "#DA4040",
    boxShadow: "0 4px 8px rgb(218 64 64 / 30%)",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 20,
    },
    "&:hover": {
      backgroundColor: "#DA4040 !important",
    },
  },
  removeLocationTooltip: {
    backgroundColor: "#DA4040 !important",
    marginTop: 5,
  },
});

const PopoverActionButton = ({
  routeLocationData,
  selectedStudentIds,
  manageStudentCallback,
  changeLocationCallback,
  removeLocationListCallback,
  schoolData,
  busScheduleType,
  routesData,
  selectedMarkers,
}: IPopoverActionButton) => {
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);

  const classes = useStyles();

  const handleClickPopOver = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget.getBoundingClientRect());
  };

  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        className={classes.MoreButton}
        onClick={handleClickPopOver}
        aria-describedby={`simple-popover-${routeLocationData.id}`}
      >
        <MoreVertIcon />
      </Button>
      <Popover
        id={`simple-popover-${routeLocationData.id}`}
        open={open}
        anchorReference="anchorPosition"
        anchorPosition={{
          top: anchorEl?.top - 10,
          left: anchorEl?.left + 180,
        }}
        onClose={handleClosePopOver}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className={classes.boxPopover}>
          <ManageStudentsButton
            routeLocationData={routeLocationData}
            selectedStudentIds={selectedStudentIds}
            manageStudentCallback={manageStudentCallback}
            schoolData={schoolData}
            busScheduleType={busScheduleType}
            routesData={routesData}
            selectedMarkers={selectedMarkers}
          />

          <ChangePickupLocationButton
            routeLocationData={routeLocationData}
            changeLocationCallback={changeLocationCallback}
          />

          <CustomTooltip
            title="Remove Location"
            aria-label="Remove Location"
            classes={{
              tooltip: classes.removeLocationTooltip,
            }}
          >
            <Button
              className={classes.removeLocationButton}
              onClick={() =>
                removeLocationListCallback(routeLocationData.postalCode)
              }
            >
              <CancelIcon />
            </Button>
          </CustomTooltip>
        </div>
      </Popover>
    </>
  );
};

export default PopoverActionButton;
